import {Component, OnInit, ViewChild} from '@angular/core';
import { MdDialogRef, MdDialog, MdDialogConfig } from '@angular/material';
import {AgregarInsumoDialogComponent} from './agregar-insumo-dialog';
import {AgrisService, HttpClient, PermisosService} from '../../../services';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Router} from '@angular/router';
import {
  AperturaFisicaViewModel,
  AperturasFisicaViewModel, CotizacionesAgrisFilterViewModel,
  InsumosViewModel,
  InsumoViewModel,
  ProveedorViewModel
} from '../common/AgrisViewModels';
import {PATH_AGRIS_COTIZACION_DETALLE, PATH_AGRIS_NUEVA_COTIZACION} from '../../../navigation/navigation.module';
import {AgrisCantidadSelectorComponent} from '../common';
import {AgregarInsACotizExistenteDialogComponent} from './agregar-ins-a-cotiz-existente-dialog';

@Component({
  selector: 'app-agris-detalle-insumo',
  templateUrl: './agris-detalle-insumo-page.component.html',
  styleUrls: ['./agris-detalle-insumo-page.component.scss', '../common/agris-common-styles.scss']
})
export class AgrisDetalleInsumoPageComponent implements OnInit {

  acordeonOpenedIndex = -1;
  subscriptions: Subscription[] = [];
  loading = true;

  @ViewChild(AgrisCantidadSelectorComponent) cantidadComponent: AgrisCantidadSelectorComponent;
  insumo: InsumoViewModel = null;
  aperturaFisica: AperturaFisicaViewModel[] = [];
  aperturaProveedor: ProveedorViewModel[] = [];
  sucursal = 0;

  addToExistenteDisabled = true;

  constructor(
    private dialog: MdDialog,
    private agrisService: AgrisService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private router: Router,
    private permServ: PermisosService,
  ) {
    permServ.verificarAccesoDeURL();
    const search = this.route.snapshot.params['id'];
    this.loading = true;
    const sub = agrisService.oficinaSucursal$.subscribe(ofiSuc => {
      // volvemos a poner el loading en true por si cambia la oficina/sucursal
      this.loading = true;
      if (ofiSuc !== null) {
        this.sucursal = ofiSuc.sucursal.Id;
        const payload: InsumosViewModel = {
          IdOficina: ofiSuc.oficina.Id,
          IdSucursal: ofiSuc.sucursal.Id,
          filter: search,
          filterFamilia: '',
          filterLinea: '',
          filterRubro: '',
          filterSubRubro: '',
          listaInsumos: []
        };
        this.subscriptions.push(
          agrisService.getInsumo(payload).subscribe(x => {
            if (x && x.Nombre && x.Nombre.length) {
              this.insumo = x;

              //apertura fisica
              const aperturaPayload: AperturasFisicaViewModel = {
                listAperturaFisica: [],
                NombreInsumo: x.Nombre,
                Oficina: ofiSuc.oficina.Id.toString(),
                Sucursal: ofiSuc.sucursal.Id.toString()
              }
              this.subscriptions.push(
                this.httpClient.postGeneric<AperturasFisicaViewModel>('/api/agris/aperturaFisica', aperturaPayload)
                  .subscribe(y => {
                    if (y && y.listAperturaFisica && y.listAperturaFisica.length) {
                      this.aperturaFisica = y.listAperturaFisica;
                    }
                  }, err => this.agrisService.showSnackbarAPIError())
              );

              //proveedor
              this.subscriptions.push(
                this.httpClient.postGeneric<ProveedorViewModel[]>('/api/agris/proveedor', {NombreInsumo: x.Nombre})
                  .subscribe(y => {
                    if (y && y.length) {
                      this.aperturaProveedor = y;
                    }
                  }, err => this.agrisService.showSnackbarAPIError())
              );

              // verificamos si podemos añadir el insumo a una cotizacion dependiendo de la oficina/sucursal disponible
              const payload: CotizacionesAgrisFilterViewModel = {
                MisCotizaciones: false,
                OrderByFechaCreacion: true,
                PageNumber: 0,
                PageSize: 100,
                filter: '',
                Pendientes: true,
                SucursalId: this.sucursal,
              }
              this.subscriptions.push(
                this.agrisService.searchCotizaciones(payload).subscribe(x => {
                  this.addToExistenteDisabled = !(x && x.length);
                }, err => {
                  this.addToExistenteDisabled = true;
                  this.agrisService.showSnackbarAPIError();
                })
              );
            }
            this.loading = false;
          }, err => {
            this.loading = false;
            this.agrisService.showSnackbarAPIError();
          })
        )
      }
    });
    this.subscriptions.push(sub);
  }

  listaPrecioTableInfo = {
    titulos: ['$ Público', '$ Min', 'Max % Desc / $ Público', 'Dosis por HA', 'Público por Dosis', 'Días Residual', 'Costo por Día', 'TRM RN2', 'Margen', 'TRM RN1'],
    anchoColumnas: ['100px', '100px', '175px', '120px', '135px', '120px', '120px', '100px', '100px', '100px']
  };

  ngOnInit() {
  }

  openAddInsumoDialog(): void {
    let dialogRef: MdDialogRef<AgregarInsumoDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '400px';
    dialogRef = this.dialog.open(AgregarInsumoDialogComponent, config);
    dialogRef.componentInstance.disabledAddToExistente = this.addToExistenteDisabled;
    dialogRef.afterClosed().subscribe(x => {
      if (x === 'nueva') {
        this.agrisService.nuevaCotizInsumo = this.insumo;
        this.agrisService.cantidadInsumo = this.cantidadComponent.cantidadValue();
        this.router.navigate([PATH_AGRIS_NUEVA_COTIZACION]);
      } else if (x === 'existente') {
        this.openAddToCotizExistenteDialog();
      }
    });
  }

  openAddToCotizExistenteDialog() {
    let dialogRef: MdDialogRef<AgregarInsACotizExistenteDialogComponent>;
    let config = new MdDialogConfig();
    config.panelClass = 'dialog-pannel-custom';
    config.width = '375px';
    dialogRef = this.dialog.open(AgregarInsACotizExistenteDialogComponent, config);
    dialogRef.componentInstance.sucursal = this.sucursal;
    dialogRef.afterClosed().subscribe(x => {
      if (x !== null && x !== undefined && x !== '') {
        this.agrisService.insumoToAddToCotiz = this.insumo;
        this.agrisService.cantidadInsumo = this.cantidadComponent.cantidadValue();
        this.router.navigate([PATH_AGRIS_COTIZACION_DETALLE, x]);
      }
    });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-detalle-insumo-page/agris-detalle-insumo-page.component.ts